import * as React from 'react';
const VerruchePlantariIcon = ({ primaryColor, secondaryColor, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Livello_2"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <defs>
      <style>{`.prefix__cls-1,.prefix__cls-2{stroke:${secondaryColor ||
        '#ffcf38'};fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px}.prefix__cls-2{stroke:${primaryColor ||
        '#282828'}}`}</style>
    </defs>
    <path
      d="M85.41 65.65c-3.73 0-8.06-4.09-8.06-9.05s3.6-7.96 8.26-7.96 7.71 2.77 7.71 7.76-2.05 6.92-2.18 7.76-.12 1.4.4 1.78 3.36.89 3.36.89M93.13 52.98c1.05-.85 4.18-2.14 6.22-1.36s3.82 2.64 3.1 4.97c-.72 2.32-2.36 7.18-2.59 8.33-.23 1.16.21 1.84.55 2.31s2.04 1.22 2.04 1.22"
      className="prefix__cls-2"
    />
    <path
      d="M102.25 57.87c.92-.74 3.66-1.87 5.44-1.19s3.34 2.31 2.7 4.34-2.06 6.27-2.26 7.28.18 1.6.48 2.02 1.78 1.07 1.78 1.07"
      className="prefix__cls-2"
    />
    <path
      d="M110.66 61.17c.84-.54 3.09-1 4.52-.27s2.38 2.44 1.79 4.22-1.53 4.04-1.79 4.79-.22 1.04-.15 1.8.75 1.65.75 1.65"
      className="prefix__cls-2"
    />
    <path
      d="M79.78 63.61c0 3.07-2.78 5.43-2.78 13.07 0 15.46 8.62 26.44 8.62 34.25 0 0-2.03 17.36-2.03 25s4.17 15.45 15.45 15.45 16.87-8.05 16.87-14.2 1.26-16.86 1.26-23.52 5.85-21.36 5.85-28.14-1.02-7.66-1.73-8.67c-.72-1.01-.82-2.09-.56-3.26s1.77-2.25 1.61-4.16-1.53-2.59-2.7-2.81-2.89.24-2.89.24"
      className="prefix__cls-2"
    />
    <circle cx={105.39} cy={86.43} r={7} className="prefix__cls-1" />
    <circle cx={105.39} cy={86.43} r={1} className="prefix__cls-1" />
    <circle cx={89.23} cy={78.43} r={1} className="prefix__cls-1" />
  </svg>
);
export default VerruchePlantariIcon;
